/* <kg-recommendations>: holt die Empfehlungen von Shopify nach, sobald der Bereich in die Naehe des Bildes kommt. */

class KgRecommendations extends HTMLElement {
  connectedCallback() {
    if (!this.dataset.url || this.dataset.geladen) return;
    if (!('IntersectionObserver' in window)) {
      this.laden();
      return;
    }
    this.observer = new IntersectionObserver(
      ([eintrag]) => {
        if (!eintrag.isIntersecting) return;
        this.observer.disconnect();
        this.laden();
      },
      /* Frueh genug, damit die Kacheln schon stehen, wenn der Bereich ins Bild kommt */
      { rootMargin: '400px 0px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async laden() {
    this.dataset.geladen = 'true';
    try {
      const antwort = await fetch(this.dataset.url);
      if (!antwort.ok) throw new Error(String(antwort.status));
      const doc = new DOMParser().parseFromString(await antwort.text(), 'text/html');
      const frisch = doc.querySelector('kg-recommendations');
      const karten = frisch?.querySelectorAll('.card-product:not(.card-product--placeholder)');
      if (!karten?.length) {
        this.leer();
        return;
      }
      /* Alles uebernehmen, nicht nur die Liste: sonst faellt die Huelle des Karussells weg */
      this.replaceChildren(...frisch.children);
    } catch {
      this.leer();
    }
  }

  /* Ohne Empfehlungen verschwindet der ganze Abschnitt, statt leer stehen zu bleiben */
  leer() {
    const bereich = this.closest('.recommendations') || this;
    bereich.remove();
  }
}

customElements.define('kg-recommendations', KgRecommendations);
